"use client";

import { useTranslations } from "next-intl";
import OtpInput from "@/common/otp-input.common";
import { RegisterContext } from "@/context";
import ArrowBackwardRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { Alert, Button, Card, Typography, useMediaQuery } from "@mui/material";
import { useContext, useState, useEffect } from "react";
import { generateOtp } from "@/api/user/otp-generator";
import { validateOTP } from "@/api/user/otp-validation";

export const OtpVerify = () => {
  const t = useTranslations();
  const { activeStep, setActiveStep, setUserToken } = useContext(RegisterContext);
  const { mobileNumber } = useContext(RegisterContext);
  const [otpText, setOtpText] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const isMobile = useMediaQuery("(max-width: 600px)");

  // Generate OTP on mount
  useEffect(() => {
    const requestOtp = async () => {
      try {
        const res = await generateOtp(mobileNumber);
        console.log("Backend OTP response:", res);
      } catch (error) {
        console.error("Error generating OTP:", error);
        setError(error.message);
      }
    };
    requestOtp();
  }, [mobileNumber]);

  const onClickVerify = async () => {
    setError("");
    setSuccess("");
    try {
      const res = await validateOTP(mobileNumber, otpText);
      if (res.message === "OTP verified successfully!") {
        setUserToken(res.user_token);
        setSuccess("OTP verified successfully!");
        setActiveStep(activeStep + 1);
      } else {
        setError(res.message || "Invalid OTP.");
      }
    } catch (err) {
      console.error("OTP verification error:", err);
      setError(err.message || "OTP verification failed.");
    }
  };

  const onClickBack = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <div>
      <Card
        sx={{
          gap: "2rem",
          maxWidth: isMobile ? "100%" : "45rem",
          margin: "auto",
          padding: isMobile ? "1rem" : "2rem",
        }}
        elevation={1}
      >
        <Typography variant="h4" gutterBottom>
          {t("OTP Verification")}
        </Typography>

        {error && <Alert severity="error">{error}</Alert>}
        {success && <Alert severity="success">{success}</Alert>}

        <Alert severity="info">
          {t("OTP has been sent to 91")}
          {mobileNumber.slice(-4)}
        </Alert>

        <div className="w-full flex flex-col gap-6 mt-4">
          <div className="w-full flex flex-col gap-1">
            <Typography variant="body1">{t("Enter 6-digit OTP")}</Typography>
            <OtpInput
              value={otpText}
              onChange={(text) => setOtpText(text)}
              inputStyle={{
                width: isMobile ? "2.5rem" : "3rem",
                height: isMobile ? "3rem" : "3.5rem",
                fontSize: isMobile ? "1rem" : "1.2rem",
                textAlign: "center",
                border: "1px solid #ccc",
                borderRadius: "0.25rem"
              }}
            />
            <Typography color="text.secondary" variant="body2">
              {t("Time remaining")}
            </Typography>
          </div>

          <Button
            variant="contained"
            fullWidth
            endIcon={<ArrowForwardRoundedIcon />}
            onClick={onClickVerify}
          >
            {t("Verify OTP")}
          </Button>

          <Button
            variant="text"
            fullWidth
            startIcon={<ArrowBackwardRoundedIcon />}
            onClick={onClickBack}
          >
            {t("Back to previous step")}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default OtpVerify;
